/*
 * STRYVE — featured-collection carousel enhancements (desktop / mouse only)
 *
 * 1. Overlay prev/next arrows centred on the product row, shown on hover and
 *    only when there is room to scroll in that direction.
 * 2. Click-and-drag (grab) scrolling with the mouse, with native image/link
 *    drag suppressed and a post-drag click guard so dragging never opens a
 *    product page.
 *
 * Scope: scroll-carousel.scroll-area inside .shopify-section--featured-collection.
 * Mobile / touch is left entirely to Impact's native scrolling.
 */
(function () {
  'use strict';

  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!finePointer || !finePointer.matches) return;

  var DRAG_THRESHOLD = 6;

  var SVG_PREV =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var SVG_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function makeArrow(direction, label, svg) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className =
      'circle-button circle-button--lg circle-button--fill border group ' +
      'stryve-carousel-arrow stryve-carousel-arrow--' + direction;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = svg;
    return btn;
  }

  function enhance(scroller) {
    if (scroller.dataset.stryveCarousel === 'on') return;

    var frame = scroller.parentElement;
    if (!frame) return;
    scroller.dataset.stryveCarousel = 'on';
    frame.classList.add('stryve-carousel-frame');

    var prev = makeArrow('prev', 'Vorherige Produkte', SVG_PREV);
    var next = makeArrow('next', 'Weitere Produkte', SVG_NEXT);
    frame.appendChild(prev);
    frame.appendChild(next);

    function positionArrows() {
      var top = scroller.offsetTop + scroller.clientHeight / 2;
      prev.style.top = top + 'px';
      next.style.top = top + 'px';
    }

    function updateAvailability() {
      var x = scroller.scrollLeft;
      var max = scroller.scrollWidth - scroller.clientWidth;
      prev.classList.toggle('is-available', x > 2);
      next.classList.toggle('is-available', x < max - 2);
    }

    function refresh() {
      positionArrows();
      updateAvailability();
    }

    function page(direction) {
      var amount = Math.max(scroller.clientWidth * 0.8, 240);
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });

    scroller.addEventListener('scroll', updateAvailability, { passive: true });
    window.addEventListener('resize', refresh);

    /* ---- drag-to-scroll (mouse only) ------------------------------------ */
    var dragging = false;
    var startX = 0;
    var startLeft = 0;
    var moved = 0;

    scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var abs = dx < 0 ? -dx : dx;
      if (abs > moved) moved = abs;
      scroller.scrollLeft = startLeft - dx;
    }

    function onUp() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('stryve-dragging');
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
    }

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      moved = 0;
      startX = e.clientX;
      startLeft = scroller.scrollLeft;
      scroller.classList.add('stryve-dragging');
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
    });

    /* If the pointer actually moved, swallow the click so the card link below
       does not navigate. Capture phase so it runs before the link handler. */
    scroller.addEventListener('click', function (e) {
      if (moved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
      }
    }, true);

    refresh();

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(refresh);
      ro.observe(scroller);
    } else {
      window.addEventListener('load', refresh);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var carousels = scope.querySelectorAll(
      '.shopify-section--featured-collection scroll-carousel.scroll-area'
    );
    for (var i = 0; i < carousels.length; i++) enhance(carousels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Re-run when a section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
